import { createI18n } from 'vue-i18n'

import en from './locales/en.json'
import kz from './locales/kz.json'
import ru from './locales/ru.json'
import zh from './locales/zh.json'

export const STORAGE_KEY = 'billing_lang'
export const SUPPORTED_LOCALES = ['ru', 'kz', 'en', 'zh']

function detectLocale() {
    let stored = localStorage.getItem(STORAGE_KEY)
    if(stored && SUPPORTED_LOCALES.includes(stored)) return stored
    return 'ru'
}

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: detectLocale(),
    fallbackLocale: 'ru',
    messages: { ru, kz, en, zh }
})

export function setLocale(locale) {
    if(!SUPPORTED_LOCALES.includes(locale)) return
    i18n.global.locale.value = locale
    localStorage.setItem(STORAGE_KEY, locale)
}

export default i18n
